import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const CommitteesPage = () => {
  // Committee data
  const committeesData = [
    {
      id: 1,
      name: "Technical Committee",
      members: [
        { sno: 1, name: "Mr. Dilip Naik" },
        { sno: 2, name: "Mr. S. N. Pradhan" },
        { sno: 3, name: "Mrs. Shweta Sengupta" },
        { sno: 4, name: "Mr. Arvind kumar" },
        { sno: 5, name: "Mr. S. Venkat" }
      ]
    },
    {
      id: 2,
      name: "Umpires Committee",
      members: [
        { sno: 1, name: "Mr. Charanjeet Singh" },
        { sno: 2, name: "Mr. Vishwas Kher" },
        { sno: 3, name: "Mr. Amarjit Singh" },
        { sno: 4, name: "Mr. Ravi Kumar" },
        { sno: 5, name: "Mr. Shamit Malli" }
      ]
    },
    {
      id: 3,
      name: "Coaches Committee",
      members: [
        { sno: 1, name: "Mr. Dilip Naik" },
        { sno: 2, name: "Mr. Ravinder Malik" },
        { sno: 3, name: "Mr. Harbir Gill" },
        { sno: 4, name: "Mr. Gopi" },
        { sno: 5, name: "Mr. Vijay Patrod" }
      ]
    },
    {
      id: 4,
      name: "Selection Committee",
      members: [
        { sno: 1, name: "Mr. P.C Bhardwaj" },
        { sno: 2, name: "Mr. Harish Kumar" },
        { sno: 3, name: "Ms. Mitali Ghosh" },
        { sno: 4, name: "Mr. Rajinder Ikahnkar" },
        { sno: 5, name: "Mr. Arvind Kumar" }
      ]
    },
    {
      id: 5,
      name: "Fund Raising Committee",
      members: [
        { sno: 1, name: "Mr. Ashok Pattan" },
        { sno: 2, name: "Mr. Ramakant S Angle" },
        { sno: 3, name: "Mr. Nand Kishore Maharia" },
        { sno: 4, name: "Mr. Jasraj Mehta" },
        { sno: 5, name: "Mr. Raju Sharma" }
      ]
    },
    {
      id: 6,
      name: "Propaganda & Publicity Committee",
      members: [
        { sno: 1, name: "Mr. M.N. Krishnamurthy" },
        { sno: 2, name: "Mr. Ashok Sharma" },
        { sno: 3, name: "Mr. J.K. Khodadhra" },
        { sno: 4, name: "Mr. Vijay Khandelwal" },
        { sno: 5, name: "Mr. Ajay Sharma" },
        { sno: 6, name: "Mr. Jai Kumar sinha" }
      ]
    },
    {
      id: 7,
      name: "Prevention of Sexual Harrassement Committee",
      members: [
        { sno: 1, name: "Ms. Madhu Sharma Chairman" },
        { sno: 2, name: "Ms. Shweta Sen Gupta" },
        { sno: 3, name: "Ms. Mitali Gosh" },
        { sno: 4, name: "Mr. Ashok Kumar" }
      ]
    },
    {
      id: 8,
      name: "Youth Committee",
      members: [
        { sno: 1, name: "Mr. Tilak Raj" },
        { sno: 2, name: "Mr. Jahar Dass" },
        { sno: 3, name: "Ms. Ashma Begum" },
        { sno: 4, name: "Mr. Ilangovane" },
        { sno: 5, name: "Mr. Omprakash mahala" },
        { sno: 6, name: "Mr. Indukiran Singh" },
        { sno: 7, name: "Mr. Anil Ram Chander" }
      ]
    },
    {
      id: 9,
      name: "Anti-Doping Commission",
      members: [
        { sno: 1, name: "Mr. Harish Kumar Chairman" },
        { sno: 2, name: "Mr. Arun Kumar" },
        { sno: 3, name: "Mr. Dilip Naik" },
        { sno: 4, name: "Mr. Mallikarjuna Reddy" }
      ]
    },
    {
      id: 10,
      name: "Age Fraud Combat",
      members: [
        { sno: 1, name: "Mr. Ajay Sharma Chairman" },
        { sno: 2, name: "Mr. Arvind Kumar" },
        { sno: 3, name: "Mr. GH Hassan Ganaie" },
        { sno: 4, name: "Mr. Rajinder Ikhankar" }
      ]
    },
    {
      id: 11,
      name: "Ethics Commission",
      members: [
        { sno: 1, name: "Mr. M.N Krishnamurthy Chairman" },
        { sno: 2, name: "Mr. Ashok Kumar" },
        { sno: 3, name: "Ms. Madhu Sharma" },
        { sno: 4, name: "Mr. Jahar Das" }
      ]
    }
  ];

  useEffect(() => {
    document.title = 'Committees | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/accounts">
          <div id="stick_right"></div>
        </Link>

        {/* Committees Content */}
        <br /><br />

        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center>
                <label className="bol">
                  <i className="fa fa-group"></i> Committees
                </label>
              </center>
              <br />
            </div>
            <div className="panel-body">
              <div className="row">
                {committeesData.map((committee, index) => (
                  <div key={committee.id} className="col-lg-3">
                    <div className="panel panel-info">
                      <div className="panel-heading">
                        <i className="fa fa-group"></i> <b>{committee.name}</b>
                      </div>
                      <div className="panel-body">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>S.No.</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {committee.members.map((member) => (
                                <tr key={member.sno}>
                                  <td>{member.sno}</td>
                                  <td>{member.name}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default CommitteesPage;